

// All colors outside material UI should be managed in: /src/styles/common/_colors.scss



// Material UI Styles

export const primaryColor = '#4F4452';


export const textUnderlineFocusStyle = {
	borderColor: "#4F4452",
}

export const textFloatingLabelFocusStyle = {
	color: "#4F4452",
}



// WEBPACK FOOTER //
// ./src/constants/materialstyle.jsx